import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/constants';
import { IDocLibrary } from '@app/models/document.model';
import { Observable } from 'rxjs';
import { delay, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentLibraryService {
  document$: Observable<IDocLibrary>;
  constructor(private http: HttpClient) {}

  /**
   * Get list of document library for Financial Institution
   */
  public getDocuments(portalAccountId): Observable<IDocLibrary> {
    if (!this.document$) {
      this.document$ = this.http.get<IDocLibrary>(
        `${Constants.appConfiguration.apiRoot}/Documents/${portalAccountId}/DocumentLibrary`
      );
    }
    return this.document$.pipe(delay(2000), shareReplay());
  }
}
